import Cookies from 'js-cookie';

export const BRIDGE_TOKEN = 'bridgeToken';
export const BRIDGE_REFRESH_TOKEN_AUTHENTICATED =
  'bridgeRefreshTokenAuthenticated';
/** Genesis user the stored `user` token belongs to (CPS-7658). */
export const BRIDGE_TOKEN_SUBJECT = 'bridgeTokenSubject';
/** Sign-out counter. Shared with every tab, like the tokens it invalidates. */
export const BRIDGE_LOGOUT_EPOCH = 'bridgeLogoutEpoch';

// Bridge does not return a refresh-token lifetime, so pin it just under the 72h
// the service issues to keep it valid past every access-token expiry.
export const BRIDGE_REFRESH_TOKEN_MAX_AGE_SECONDS = 60 * 60 * 71;

// js-cookie takes an absolute expiry, not a maxAge.
const setWithMaxAge = (name: string, value: string, maxAgeSeconds: number) => {
  Cookies.set(name, value, {
    expires: new Date(Date.now() + maxAgeSeconds * 1000),
    // Bearer credentials: HTTPS-only everywhere except local http dev.
    secure: process.env.NODE_ENV !== 'development',
    sameSite: 'lax',
  });
};

export const isValidToken = (token: unknown): token is string =>
  typeof token === 'string' && token.trim().length > 0;

export const storeBridgeAccessToken = (
  accessToken: string,
  expiresInSeconds: number
) => setWithMaxAge(BRIDGE_TOKEN, accessToken, expiresInSeconds);

export const storeBridgeRefreshToken = (refreshToken: string) =>
  setWithMaxAge(
    BRIDGE_REFRESH_TOKEN_AUTHENTICATED,
    refreshToken,
    BRIDGE_REFRESH_TOKEN_MAX_AGE_SECONDS
  );

export const storeBridgeTokenSubject = (userId: string) =>
  setWithMaxAge(
    BRIDGE_TOKEN_SUBJECT,
    userId,
    BRIDGE_REFRESH_TOKEN_MAX_AGE_SECONDS
  );

export const readBridgeTokenSubject = () => Cookies.get(BRIDGE_TOKEN_SUBJECT);

export const readBridgeLogoutEpoch = () =>
  Cookies.get(BRIDGE_LOGOUT_EPOCH) ?? '';

/** Outlives the tokens it invalidates, so it is not part of the teardown. */
export const bumpBridgeLogoutEpoch = () =>
  setWithMaxAge(
    BRIDGE_LOGOUT_EPOCH,
    String(Number(readBridgeLogoutEpoch() || 0) + 1),
    BRIDGE_REFRESH_TOKEN_MAX_AGE_SECONDS
  );

export const readBridgeAccessToken = () => Cookies.get(BRIDGE_TOKEN);

export const readBridgeRefreshToken = () =>
  Cookies.get(BRIDGE_REFRESH_TOKEN_AUTHENTICATED);

export const deleteUserBridgeTokens = () => {
  Cookies.remove(BRIDGE_TOKEN);
  Cookies.remove(BRIDGE_REFRESH_TOKEN_AUTHENTICATED);
  Cookies.remove(BRIDGE_TOKEN_SUBJECT);
};
